<template>
  <div id="main-page">
    <div class="space"></div>
    <div v-for="(design, did) in featuredDesigns" :key="did" class="designs">
      <design-entry :design="design" @shop="gotoProduct"/>
    </div>
  </div>
</template>

<script>
import Product from '@/data/featuredProduct.json';
import FeatureService from '@/services/FeaturedService';
import DesignEntry from '@/components/homepage/designs/DesignEntry.vue';

export default {
  name: 'MainPage',
  components: {
    DesignEntry
  },
  data() {
    return {
      product: null,
      currentSection: 'homepage',
      featuredDesigns: [],
    };
  },

  methods: {
    gotoProduct(product) {
      this.$router.push(`/products/${product._id}`);
    },
  },

  created() {
    this.product = Product;
    FeatureService.getFeatureListFor(this.currentSection)
      .then((data) => {
        this.featuredDesigns = data;
      })
      .catch((err) => { console.log(err); });
  },
};
</script>

<style lang="scss">
@import '../../assets/css/constants.scss';

.designs{
  margin-bottom: 1rem;
}
.veniqa-button:hover {
  background-color: $pitch-black;
  border: 2px solid $pitch-black;
}
.absolute-buttons {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-bottom: 100px;
}

.jumbotron {
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
}
.featured-title {
  margin: 0px 0px 0px 0px;
  padding: 40px 10px;
  color: #5d6d7e;
  // background-color: #eaecee;
  font-family: 'Quicksand';
}
</style>
